'use client';

import React, { createContext, useContext, useEffect } from 'react';

export interface FeatureFlags {
  'minimalist-edd': boolean;
  'sublime-delivery-notifications': boolean;
  'track-only-optin': boolean;
  'notification-preferences-unsubscribe': boolean;
  'rm-fetch-design': string;
  'rm-disco-cover-indigo': string;
  'rm-media-enabled': string;
  'rm-banner-ads': string;
  'rm-disco-edd-drawer': string;
}

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  'minimalist-edd': false,
  'sublime-delivery-notifications': false,
  'track-only-optin': false,
  'notification-preferences-unsubscribe': false,
  'rm-fetch-design': 'NOT_ENROLLED',
  'rm-disco-cover-indigo': 'NOT_ENROLLED',
  'rm-media-enabled': 'NOT_ENROLLED',
  'rm-banner-ads': 'NOT_ENROLLED',
  'rm-disco-edd-drawer': 'NOT_ENROLLED',
};

const FeatureFlagsContext = createContext<FeatureFlags>(DEFAULT_FEATURE_FLAGS);

export function FeatureFlagsProvider({
  flags,
  children,
}: {
  flags: FeatureFlags;
  children?: React.ReactNode;
}) {
  useEffect(() => {
    window.__FEATURE_FLAGS__ = flags;
  }, [flags]);

  return (
    <FeatureFlagsContext.Provider value={flags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

export function useFeatureFlag<K extends keyof FeatureFlags>(
  key: K,
): FeatureFlags[K] {
  return useContext(FeatureFlagsContext)[key];
}
